/**
 * Hub vs Megaventory ownership for `public.sales_order`.
 *
 * There is no `system_of_record` column. A positive `mv_id` means Megaventory already has
 * the document: sweeps apply the Megaventory projection, and hub must not edit MV-owned
 * commercial fields. Hub-only rows (`mv_id` null) stay fully editable until ingest links them.
 */

export const SALES_ORDER_MEGAVENTORY_CONTROLLED_EDIT_MESSAGE =
  "This sales order is linked to Megaventory. Addresses, line items, dates, and customer fields must be edited in Megaventory.";

/** Activity-log field ids that Megaventory owns once `mv_id` is set. */
export const SALES_ORDER_MEGAVENTORY_CONTROLLED_ACTIVITY_FIELDS = new Set<string>([
  "number",
  "shipByDate",
  "customerPurchaseOrderNumber",
  "paymentTerms",
  "clientFsAccountId",
  "endUserFsAccountId",
  "shipTo",
  "billTo",
  "specialInstructions",
  "pilotProgram",
  "items",
]);

export function salesOrderIsMegaventoryControlled(mvId: unknown): boolean {
  if (mvId == null || mvId === "") {
    return false;
  }
  const parsed = typeof mvId === "number" ? mvId : Number(mvId);
  return Number.isFinite(parsed) && parsed > 0;
}

export function salesOrderBlockedMegaventoryControlledChanges(
  changes: Array<{ field: string; label: string }>,
): Array<{ field: string; label: string }> {
  return changes.filter((change) => SALES_ORDER_MEGAVENTORY_CONTROLLED_ACTIVITY_FIELDS.has(change.field));
}

export function assertSalesOrderHubMayEditMegaventoryFields(args: {
  mvId: unknown;
  changes: Array<{ field: string; label: string }>;
}): void {
  if (!salesOrderIsMegaventoryControlled(args.mvId)) {
    return;
  }
  const blocked = salesOrderBlockedMegaventoryControlledChanges(args.changes);
  if (blocked.length > 0) {
    throw new Error(SALES_ORDER_MEGAVENTORY_CONTROLLED_EDIT_MESSAGE);
  }
}
